module.exports = {"TXTWCL_All_N0_Markets":{"id":"TXTWCL_All_N0_Markets","defaultMessage":"Todos los mercados de {0}"}}